import React, { createContext } from "react";

const PlaylistsContext = createContext();

export default PlaylistsContext;
